<template>
    <BaseModal :width="360" title="清空确认" v-model="show">
        <a-alert :show-icon="true" message="清除相册内所有上传内容，请务必先做好数据备份，此操作无法恢复！"
                 type="warning"/>
        <div style="position: relative;margin: 20px 0;">
            <a-input placeholder="请输入6位操作确认验证码" v-model="code">
                <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="lock"/>
                <VueCodeButton @click="sendCode" class="code-button" slot="suffix"/>
            </a-input>
        </div>
        <div style="width: 140px; margin: 0 auto;">
            <SaveButton :action="submit" :disabled="!code" title="确认删除" type="danger"/>
        </div>
    </BaseModal>
</template>

<script>
    import api from "../../../../../utils/api";
    import BaseModal from "../../../../../comps/BaseModal";
    import SaveButton from "../../../../../comps/SaveButton";
    import {VueCodeButton} from "@basic/vue-code";

    export default {
        name: "CleanConfirm",
        components: {SaveButton, BaseModal, VueCodeButton},
        props: {
            albumId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                code: "",
                show: false,
            }
        },
        methods: {
            open() {
                this.show = true
            },
            submit() {
                return api.v1.album.photo
                    .clean(this.albumId, this.code)
                    .then(() => {
                        this.show = false;
                        this.$emit("success");
                        this.$message.success("清空成功");
                    })
                    .catch((err) => {
                        console.log(err); // debug
                        this.$message.error("清空失败");
                    });
            },
            sendCode() {
                return api.v1.album.vcode(this.albumId);
            }
        }
    }
</script>

<style lang="less" scoped>
    .code-button {
        margin-right: -8px;
    }
</style>
